module.exports = __webpack_public_path__ + "static/media/ehealth-bg2-4-3.64796d20.jpg";